import React, { useCallback, useState } from 'react';

import api from '../api';
import {
    useGet,
    useGetOne,
    usePost,
    usePut,
    useRemove,
    useSoftDelete
} from '../../apiHooks';
import { DocumentCounter } from '../model';

import Context from './context';

interface Props {
    children: React.ReactNode;
}

const DocumentCountersProvider: React.FC<Props> = ({ children }) => {
    const [data, setData] = useState<Array<DocumentCounter>>([]);
    const [selected, setSelected] = useState<DocumentCounter | null>(null);
    const [error, setError] = useState({});

    const handleGetData = useCallback((res) => {
        setData(res);
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);
    const getOne = useGetOne(api, setSelected, setError);

    const handleUpdateData = useCallback((item: DocumentCounter) => {
        setData((prev) => {
            const exists = prev.find((row) => row._id === item._id);
            if (exists) {
                return prev.map((row) => (row._id === item._id ? item : row));
            } else {
                return [...prev, item];
            }
        });
    }, []);

    const post = usePost(api, data, handleUpdateData, setError);
    const put = usePut(api, data, handleUpdateData, setError);

    const handleDeleteCallback = useCallback((id: string, newData: DocumentCounter[]) => {
        setData(newData);
        setSelected(null);
        return id;
    }, []);
    const remove = useRemove(api, data, handleDeleteCallback, setError);
    const softDelete = useSoftDelete(api, data, handleDeleteCallback, setError);

    return (
        <Context.Provider
            value={{
                get,
                getOne,
                post,
                put,
                remove,
                softDelete,
                data,
                setData,
                selected,
                setSelected,
                error
            }}
        >
            {children}
        </Context.Provider>
    );
};

export default DocumentCountersProvider;